export function formatMoney(num, forcedDec) {
  const numIsInteger = Number((num % 1).toFixed(2)) === 0;
  const defaultDec = numIsInteger ? 0 : 2;
  const dec = forcedDec === undefined ? defaultDec : forcedDec;
  return new Intl.NumberFormat("ca-CA", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: dec,
    maximumFractionDigits: dec,
  }).format(num);
}

export function formatMoneyNum(num, forcedDec) {
  const money = formatMoney(num, forcedDec);
  return money.replace("€", "").trim();
}

export function formatPercent(num) {
  return new Intl.NumberFormat("ca-CA", {
    style: "percent",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
    .format(num)
    .replace("%", "")
    .trim();
}

export function formatDeleteSpacesInStringAndUpperCase(str) {
  return str.replace(/\s/g, "").toUpperCase();
}
export function formatNumber(num) {
  return new Intl.NumberFormat("ca-CA", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
}

export function parseStringAmountWithUnitToNumber(str) {
  return str
    ? Number(str.replace(/\./g, "").replace(/,/g, ".").slice(0, -2))
    : null;
}

export const emailPattern =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const phonePattern = /^\d{9}$/;

export function formatSnakecaseToSpaces(text) {
  return text.replace(/_/g, " ");
}

export function normalizeText(text) {
  return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export const formatAmountForDisplay = (amt, digits = 1) => {
  const Ks = amt / 1000;
  if (Ks >= 1000) {
    return `${(Ks / 1000).toFixed(digits)}M`;
  }
  return `${Ks.toFixed(digits)}K`;
};

export const formatIBAN = (iban) => {
  iban = iban.replace(/\s/g, "");
  const groupSize = 4;
  const groups = iban.match(new RegExp(`.{1,${groupSize}}`, "g"));
  const formattedIBAN = groups.join(" ");
  return formattedIBAN;
};
